import * as types from './types';

export const setSelectedAiAlert = (payload) => ({
  type: types.SET_SELECTED_AI_ALERT,
  payload,
});

export const setAllExceptAnomalyPayload = (payload) => ({
  type: types.SET_ALL_EXCEPT_ANOMALY_PAYLOAD,
  payload,
});

export const resetAiAlertState = () => ({
  type: types.RESET_ALERT_STATE,
});
